export default "__VITE_ASSET__616b3740__"